import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { CanliGuncellemeService } from '@/src/service/fikoyt-ui/src/lib/dinamik-bilesen/canli-guncelleme.service';

const DURUMLAR = [
  { isim: 'Planlandı',    renk: '#94a3b8', ikon: '⏳' },
  { isim: 'Devam Ediyor', renk: '#3b82f6', ikon: '🚀' },
  { isim: 'Beklemede',    renk: '#f59e0b', ikon: '⏸️' },
  { isim: 'Tamamlandı',   renk: '#22c55e', ikon: '✅' },
  { isim: 'İptal',        renk: '#ef4444', ikon: '❌' },
];
const DURUM_RENK: Record<string, string> = Object.fromEntries(DURUMLAR.map(d => [d.isim, d.renk]));
const DURUM_IKON: Record<string, string> = Object.fromEntries(DURUMLAR.map(d => [d.isim, d.ikon]));
const DURUM_VARSAYILAN_DEGER: Record<string, number> = {
  'Planlandı': 10,
  'Beklemede': 25,
  'Devam Ediyor': 50,
  'Tamamlandı': 100,
  'İptal': 0,
};

const KATEGORI_OPS = ['Üretim', 'AR-GE', 'Bakım', 'Tasarım', 'Diğer'];
const ONCELIK_OPS = [
  { value: 'Düşük',  renk: '#94a3b8' },
  { value: 'Normal', renk: '#3b82f6' },
  { value: 'Yüksek', renk: '#f59e0b' },
  { value: 'Kritik', renk: '#ef4444' },
];

// ════════════════════════════════════════════════════
// 1. EDIT COMPONENT (paylas kutusunda form)
// ════════════════════════════════════════════════════
@Component({
  selector: 'proje-tanimi-edit',
  standalone: true,
  imports: [CommonModule, FormsModule, NzInputModule, NzSelectModule, NzDatePickerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pe">
      <div class="pe-baslik">
        <span class="pe-ikon">📂</span>
        <span>Proje Tanımı</span>
      </div>

      <div class="pe-form">
        <div class="pe-alan">
          <label class="pe-etiket">Proje Adı <span class="zorunlu">*</span></label>
          <input nz-input nzSize="small" [ngModel]="p()?.projeAdi || ''" (ngModelChange)="guncelle('projeAdi', $event)" placeholder="Proje adını giriniz"/>
        </div>

        <div class="pe-row">
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Proje Kodu</label>
            <input nz-input nzSize="small" [ngModel]="p()?.projeKodu || ''" (ngModelChange)="guncelle('projeKodu', $event)" placeholder="Örn: PRJ-2026-001"/>
          </div>
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Müşteri</label>
            <input nz-input nzSize="small" [ngModel]="p()?.musteri || ''" (ngModelChange)="guncelle('musteri', $event)" placeholder="Müşteri adı"/>
          </div>
        </div>

        <div class="pe-row">
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Kategori</label>
            <nz-select nzSize="small" [ngModel]="p()?.kategori" (ngModelChange)="guncelle('kategori', $event)" nzPlaceHolder="Kategori seçin" nzAllowClear style="width:100%">
              @for (k of kategoriOps; track k) {
                <nz-option [nzValue]="k" [nzLabel]="k"></nz-option>
              }
            </nz-select>
          </div>
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Öncelik</label>
            <nz-select nzSize="small" [ngModel]="p()?.oncelik" (ngModelChange)="guncelle('oncelik', $event)" nzPlaceHolder="Öncelik seçin" nzAllowClear style="width:100%">
              @for (o of oncelikOps; track o.value) {
                <nz-option [nzValue]="o.value" [nzLabel]="o.value"></nz-option>
              }
            </nz-select>
          </div>
        </div>

        <div class="pe-row">
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Başlangıç Tarihi</label>
            <nz-date-picker nzSize="small" [ngModel]="p()?.baslangicTarihi" (ngModelChange)="guncelle('baslangicTarihi', $event)" nzFormat="dd.MM.yyyy" style="width:100%"></nz-date-picker>
          </div>
          <div class="pe-alan" style="flex:1">
            <label class="pe-etiket">Hedef Bitiş</label>
            <nz-date-picker nzSize="small" [ngModel]="p()?.hedefBitis" (ngModelChange)="guncelle('hedefBitis', $event)" nzFormat="dd.MM.yyyy" style="width:100%"></nz-date-picker>
          </div>
        </div>

        <div class="pe-alan">
          <label class="pe-etiket">Sorumlu</label>
          <input nz-input nzSize="small" [ngModel]="p()?.sorumlu || ''" (ngModelChange)="guncelle('sorumlu', $event)" placeholder="Sorumlu kişi"/>
        </div>

        <div class="pe-bilgi">
          💡 İlerleme % alt kart durumlarına göre <b>otomatik</b> hesaplanır
        </div>

        <div class="pe-alan">
          <label class="pe-etiket">Açıklama</label>
          <textarea nz-input [ngModel]="p()?.aciklama || ''" (ngModelChange)="guncelle('aciklama', $event)" placeholder="Proje açıklaması..." rows="3"></textarea>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .pe { display:flex; flex-direction:column; gap:10px; padding:4px 0; }
    .pe-baslik { display:flex; align-items:center; gap:8px; padding:8px 12px; background:linear-gradient(135deg, rgba(59,130,246,.08), transparent); border-radius:8px; font-weight:600; font-size:14px; color:var(--py-metin,#333); }
    .pe-ikon { font-size:20px; }
    .pe-form { display:flex; flex-direction:column; gap:8px; }
    .pe-row { display:flex; gap:8px; }
    .pe-alan { display:flex; flex-direction:column; gap:3px; }
    .pe-etiket { font-size:11px; font-weight:600; color:var(--py-metin-ucuncul,#999); text-transform:uppercase; letter-spacing:.4px; }
    .zorunlu { color:#ef4444; }
    .pe-bilgi { padding:6px 10px; font-size:11px; color:var(--py-metin-ikincil,#666); background:rgba(59,130,246,.06); border-left:3px solid #3b82f6; border-radius:0 6px 6px 0; }
  `],
})
export class ProjeTanimiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  kategoriOps = KATEGORI_OPS;
  oncelikOps = ONCELIK_OPS;

  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}

// ════════════════════════════════════════════════════
// 2. KART-SADE COMPONENT (paylaşılan kart görünümü)
// ════════════════════════════════════════════════════
@Component({
  selector: 'proje-tanimi-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pks">
      <!-- Üst başlık + kategori/öncelik chip -->
      <div class="pks-ust">
        <div class="pks-baslik">
          <span class="pks-ikon">📂</span>
          <span class="pks-ad">{{ d('projeAdi') || 'İsimsiz Proje' }}</span>
          @if (d('projeKodu')) { <span class="pks-kod">{{ d('projeKodu') }}</span> }
        </div>
        <div class="pks-chipler">
          @if (d('kategori')) { <span class="pks-chip pks-chip--kategori">{{ d('kategori') }}</span> }
          @if (d('oncelik')) { <span class="pks-chip pks-chip--oncelik" [style.--oc]="oncelikRenk()">{{ d('oncelik') }}</span> }
        </div>
      </div>

      <!-- Müşteri / Sorumlu / Tarihler -->
      <div class="pks-bilgi">
        @if (d('musteri')) { <div class="pks-meta"><span class="pks-meta-et">🏢 Müşteri</span><span class="pks-meta-deg">{{ d('musteri') }}</span></div> }
        @if (d('sorumlu')) { <div class="pks-meta"><span class="pks-meta-et">👤 Sorumlu</span><span class="pks-meta-deg">{{ d('sorumlu') }}</span></div> }
        @if (d('baslangicTarihi') || d('hedefBitis')) {
          <div class="pks-meta">
            <span class="pks-meta-et">📅 Tarih</span>
            <span class="pks-meta-deg">{{ tarihFormat(d('baslangicTarihi')) }} → {{ tarihFormat(d('hedefBitis')) }}</span>
          </div>
        }
      </div>

      <!-- İlerleme bar (alt kart durumlarından otomatik) -->
      @if (altToplam() > 0 || ilerlemeYuzde() > 0) {
        <div class="pks-ilerleme-blok">
          <div class="pks-ilerleme-bilgi">
            <span class="pks-meta-et">📊 İlerleme</span>
            <span class="pks-gorev-bilgi">
              @if (altToplam() > 0) {
                <span class="pks-gorev">{{ altTamamlanan() }}/{{ altToplam() }} görev</span>
              }
              <span class="pks-yuzde">{{ ilerlemeYuzde() }}%</span>
            </span>
          </div>
          <div class="pks-bar"><div class="pks-bar-dolgu" [style.width.%]="ilerlemeYuzde()" [style.background]="ilerlemeRenk()"></div></div>
        </div>
      }

      <!-- Açıklama -->
      @if (d('aciklama')) { <div class="pks-aciklama">{{ d('aciklama') }}</div> }

      <!-- Durum butonları -->
      <div class="pks-durum-bar">
        @for (dr of durumlar; track dr.isim) {
          <button class="pks-durum-btn"
            [class.pks-durum-aktif]="sonDurum() === dr.isim"
            [style.--dr]="dr.renk"
            [disabled]="durumKaydediliyor()"
            (click)="durumDegistir(dr.isim)">
            <span>{{ dr.ikon }}</span>
            <span>{{ dr.isim }}</span>
          </button>
        }
      </div>
    </div>
  `,
  styles: [`
    .pks { display:flex; flex-direction:column; gap:8px; }
    .pks-ust { display:flex; flex-direction:column; gap:6px; padding-bottom:6px; border-bottom:1px solid var(--py-kenarlik,#f0f0f0); }
    .pks-baslik { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
    .pks-ikon { font-size:18px; }
    .pks-ad { font-size:15px; font-weight:700; color:var(--py-metin,#333); }
    .pks-kod { font-size:11px; font-family:'Consolas',monospace; color:var(--py-metin-ucuncul,#999); padding:2px 6px; background:var(--py-arkaplan-soluk,rgba(0,0,0,.04)); border-radius:4px; }
    .pks-chipler { display:flex; gap:6px; flex-wrap:wrap; }
    .pks-chip { padding:3px 8px; border-radius:10px; font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:.3px; }
    .pks-chip--kategori { background:rgba(59,130,246,.12); color:#3b82f6; }
    .pks-chip--oncelik { background:color-mix(in srgb, var(--oc, #94a3b8) 12%, transparent); color:var(--oc, #94a3b8); }
    .pks-bilgi { display:flex; flex-direction:column; gap:4px; padding:4px 0; }
    .pks-meta { display:flex; gap:8px; font-size:12px; }
    .pks-meta-et { color:var(--py-metin-ucuncul,#999); min-width:80px; font-size:11px; }
    .pks-meta-deg { color:var(--py-metin,#333); font-weight:500; }
    .pks-ilerleme-blok { display:flex; flex-direction:column; gap:4px; padding:6px 0; }
    .pks-ilerleme-bilgi { display:flex; justify-content:space-between; align-items:center; }
    .pks-gorev-bilgi { display:flex; align-items:center; gap:8px; }
    .pks-gorev { font-size:11px; color:var(--py-metin-ucuncul,#999); padding:2px 6px; background:var(--py-arkaplan-soluk,rgba(0,0,0,.04)); border-radius:4px; font-family:'Consolas',monospace; }
    .pks-gorev--bos { font-style:italic; opacity:.7; }
    .pks-yuzde { font-size:13px; font-weight:700; color:var(--py-metin,#333); font-family:'Consolas',monospace; }
    .pks-bar { width:100%; height:6px; background:var(--py-arkaplan-soluk,rgba(0,0,0,.06)); border-radius:3px; overflow:hidden; }
    .pks-bar-dolgu { height:100%; transition:width .3s ease, background .2s ease; border-radius:3px; }
    .pks-aciklama { padding:6px 8px; font-size:12px; color:var(--py-metin-ikincil,#666); background:var(--py-arkaplan-soluk,rgba(0,0,0,.02)); border-radius:6px; line-height:1.4; }
    .pks-durum-bar { display:flex; gap:4px; flex-wrap:wrap; margin-top:4px; }
    .pks-durum-btn { display:flex; align-items:center; gap:3px; padding:4px 8px; border:1px solid var(--py-kenarlik,#e5e7eb); border-radius:6px; background:transparent; cursor:pointer; font-size:11px; font-weight:500; color:var(--py-metin-ikincil,#666); transition:all .15s;
      &:hover { border-color:var(--dr); color:var(--dr); background:color-mix(in srgb, var(--dr) 8%, transparent); }
      &:disabled { opacity:.5; cursor:wait; }
    }
    .pks-durum-aktif { border-color:var(--dr) !important; color:var(--dr) !important; background:color-mix(in srgb, var(--dr) 12%, transparent) !important; font-weight:700; }
  `],
})
export class ProjeTanimiKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  durumlar = DURUMLAR;
  durumKaydediliyor = signal(false);
  private canliGuncelleme = inject(CanliGuncellemeService);

  /** Yerel kart kopyası — reactive mutation için */
  kartObj = signal<any>(null);
  private sonHesaplananId: string | null = null;

  constructor() {
    super();
    effect(() => {
      const kart = this.parametreler()?.kart;
      this.kartObj.set(kart || null);
    });
    effect(() => {
      const k = this.kartObj();
      if (k?._id && !k?._hesap?.projeSonDurum) {
        this.sonDurumCek(k._id);
      }
    });
    // Kart değiştiğinde ilerlemeyi otomatik yeniden hesapla (paylaş kutusundan eklenen alt kartlar için)
    effect(() => {
      const k = this.kartObj();
      if (k?._id && k._id !== this.sonHesaplananId) {
        this.sonHesaplananId = k._id;
        this.ilerlemeyiYenidenHesapla(k._id);
      }
    });
    // Canlı güncelleme: yeni bir alt kart/içerik eklendiğinde bu karta aitse ilerlemeyi yeniden hesapla
    effect(() => {
      const yeni = this.canliGuncelleme.kartYeni();
      const k = this.kartObj();
      if (!yeni || !k?._id) return;
      if (yeni._uid === k._id || yeni?.veri?._uid === k._id) {
        this.ilerlemeyiYenidenHesapla(k._id);
      }
    });
    effect(() => {
      const g = this.canliGuncelleme.kartGuncellendi();
      const k = this.kartObj();
      if (!g || !k?._id) return;
      if (g.veri?._uid === k._id || g.kartId === k._id) {
        this.ilerlemeyiYenidenHesapla(k._id);
      }
    });
  }

  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }

  sonDurum = computed(() => {
    const k = this.kartObj();
    return k?._hesap?.projeSonDurum || this.d('durum') || 'Planlandı';
  });

  /** Alt kart durumlarına göre hesaplanmış ilerleme (prepipe'tan gelir) */
  ilerlemeYuzde = computed(() => {
    const k = this.kartObj();
    const v = +(k?._hesap?.projeIlerleme ?? 0);
    return Math.max(0, Math.min(100, v));
  });

  altToplam = computed(() => +(this.kartObj()?._hesap?.projeAltToplam || 0));
  altTamamlanan = computed(() => +(this.kartObj()?._hesap?.projeAltTamamlanan || 0));

  ilerlemeRenk = computed(() => {
    const y = this.ilerlemeYuzde();
    if (y >= 100) return 'linear-gradient(90deg, #22c55e, #16a34a)';
    if (y >= 75) return 'linear-gradient(90deg, #3b82f6, #22c55e)';
    if (y >= 50) return 'linear-gradient(90deg, #f59e0b, #3b82f6)';
    if (y >= 25) return 'linear-gradient(90deg, #ef4444, #f59e0b)';
    return 'linear-gradient(90deg, #94a3b8, #ef4444)';
  });

  oncelikRenk = computed(() => {
    const o = ONCELIK_OPS.find(x => x.value === this.d('oncelik'));
    return o?.renk || '#94a3b8';
  });

  tarihFormat(t: any): string {
    if (!t) return '—';
    try {
      const d = new Date(t);
      if (isNaN(d.getTime())) return '—';
      return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch { return '—'; }
  }

  // ─── Durum güncelleme akışı (cam-kutuk-kart-sade gibi) ───
  private async sonDurumCek(kartId: string) {
    try {
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
      istek.parametreler = { aggregate: [
        { $match: { _uid: kartId, silindi: { $ne: true }, turu: 'KART' } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } },
        { $match: { 'ic.ek._secilenSetId': 'proje.tanimi.durum' } },
        { $sort: { _id: -1 } },
        { $limit: 1 },
        { $project: { 'ic.ek.durum': 1 } },
      ] };
      const cevap: any = await istek.isteSync();
      const durum = cevap?.cevap?.sonuc?.[0]?.ic?.ek?.durum;
      if (durum) this._kartHesapGuncelle({ projeSonDurum: durum });
    } catch {}
  }

  private _kartHesapGuncelle(yenilenenler: any) {
    const k = this.kartObj();
    if (!k) return;
    this.kartObj.set({ ...k, _hesap: { ...(k._hesap || {}), ...yenilenenler } });
  }

  private ekleIstek = new FikoYTIstekKok({
    metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.ekle',
    onEkOlsun: true, depoModu: false, oncelik: 0, gecikmeliCevap: false,
  });

  async durumDegistir(yeniDurum: string) {
    if (this.sonDurum() === yeniDurum || this.durumKaydediliyor()) return;
    const kartId = this.parametreler()?.kart?._id;
    if (!kartId) return;

    this.durumKaydediliyor.set(true);
    try {
      const kartKimlik = this.FikoYT.fikoIdUret();
      const icerikKimlik = this.FikoYT.fikoIdUret();
      const sahip = this.FikoYT.kimlik.aktifKullaniciJson()?._id;

      const kart: any = {
        _id: kartKimlik,
        vt: 'FikoYT.sistem.hareketler',
        yol: 'FikoYT.sistem.hareketler.kalem',
        turu: 'KART',
        gizlilik: 'Herkese Açık',
        _uid: kartId,
        sahip,
        tarih: new Date(),
        veri: {
          solSimge: { baslik: '🔄', renkArka: '#3b82f6', renkYazi: '#fff' },
          icerikler: [icerikKimlik],
        },
      };

      const icerik: any = {
        _id: icerikKimlik,
        _uid: kartKimlik,
        html: '', aciklama: '', sifre: null,
        ek: {
          turu: 'UYGULAMAICERIK',
          _secilenSetId: 'proje.tanimi.durum',
          bilesen: 'proje-tanimi-durum',
          durum: yeniDurum,
          ilerlemeTipi: 'kesin',
          ilerlemeDegeri: DURUM_VARSAYILAN_DEGER[yeniDurum] ?? 0,
        },
      };

      const fd1 = new FormData();
      fd1.append('req_body', JSON.stringify(kart));
      this.ekleIstek.parametreler = fd1;
      await this.ekleIstek.isteSync();

      const fd2 = new FormData();
      fd2.append('req_body', JSON.stringify(icerik));
      this.ekleIstek.parametreler = fd2;
      await this.ekleIstek.isteSync();

      this._kartHesapGuncelle({ projeSonDurum: yeniDurum });
      // Yeni durum kaydedildikten sonra ilerlemeyi DB'den yeniden hesapla
      this.ilerlemeyiYenidenHesapla(kartId);
      this.nzMessage.success(`Durum: ${yeniDurum}`);
    } catch {
      this.nzMessage.error('Durum güncellenemedi');
    } finally {
      this.durumKaydediliyor.set(false);
    }
  }

  /** Alt kart durumları değiştikten sonra ilerlemeyi DB'den $reduce ile yeniden hesapla */
  private async ilerlemeyiYenidenHesapla(kartId: string) {
    try {
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
      istek.parametreler = { aggregate: [
        { $match: { _uid: kartId, turu: 'KART', silindi: { $ne: true } } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } },
        { $match: { 'ic.ek._secilenSetId': 'proje.tanimi.durum' } },
        { $sort: { _id: 1 } },
        { $addFields: {
            _ilerlemeTipi: { $ifNull: ['$ic.ek.ilerlemeTipi', 'kesin'] },
            _ilerlemeDeger: {
              $cond: [
                { $and: [{ $ne: ['$ic.ek.ilerlemeDegeri', null] }, { $ne: ['$ic.ek.ilerlemeDegeri', ''] }] },
                { $convert: { input: '$ic.ek.ilerlemeDegeri', to: 'double', onError: 0, onNull: 0 } },
                { $switch: { branches: [
                  { case: { $eq: ['$ic.ek.durum', 'Tamamlandı'] }, then: 100 },
                  { case: { $eq: ['$ic.ek.durum', 'Devam Ediyor'] }, then: 50 },
                  { case: { $eq: ['$ic.ek.durum', 'Beklemede'] }, then: 25 },
                  { case: { $eq: ['$ic.ek.durum', 'Planlandı'] }, then: 10 },
                  { case: { $eq: ['$ic.ek.durum', 'İptal'] }, then: 0 },
                ], default: 0 } }
              ]
            }
        } },
        { $group: { _id: null, kayitlar: { $push: { tipi: '$_ilerlemeTipi', deger: '$_ilerlemeDeger', durum: '$ic.ek.durum' } } } },
        { $addFields: {
            hamIlerleme: {
              $reduce: {
                input: '$kayitlar',
                initialValue: 0,
                in: {
                  $cond: [
                    { $eq: ['$$this.tipi', 'eklemeli'] },
                    { $add: ['$$value', '$$this.deger'] },
                    '$$this.deger'
                  ]
                }
              }
            },
            toplam: { $size: '$kayitlar' },
            tamamlanan: {
              $size: { $filter: { input: '$kayitlar', cond: { $or: [
                { $eq: ['$$this.durum', 'Tamamlandı'] },
                { $gte: ['$$this.deger', 100] }
              ] } } }
            }
        } },
        { $addFields: { ilerleme: { $max: [0, { $min: [100, '$hamIlerleme'] }] } } }
      ] };
      const cevap: any = await istek.isteSync();
      const sonuc = cevap?.cevap?.sonuc?.[0];
      this._kartHesapGuncelle({
        projeIlerleme: Math.round(+(sonuc?.ilerleme || 0)),
        projeAltToplam: +(sonuc?.toplam || 0),
        projeAltTamamlanan: +(sonuc?.tamamlanan || 0),
      });
    } catch {}
  }
}

// ════════════════════════════════════════════════════
// 3a. DURUM EDIT (alt kart paylaş kutusu formu)
// ════════════════════════════════════════════════════
@Component({
  selector: 'proje-tanimi-durum-edit',
  standalone: true,
  imports: [CommonModule, FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule, NzSegmentedModule, NzSliderModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pde">
      <div class="pde-baslik">
        <span class="pde-ikon">{{ secilenIkon() }}</span>
        <span>Durum Güncelleme</span>
      </div>

      <div class="pde-form">
        <div class="pde-alan">
          <label class="pde-etiket">Durum <span class="zorunlu">*</span></label>
          <nz-select nzSize="small" [ngModel]="p()?.durum" (ngModelChange)="durumDegisti($event)" nzPlaceHolder="Durum seçin" style="width:100%">
            @for (d of durumlar; track d.isim) {
              <nz-option [nzValue]="d.isim" [nzLabel]="d.ikon + ' ' + d.isim"></nz-option>
            }
          </nz-select>
        </div>

        <div class="pde-alan">
          <label class="pde-etiket">İlerleme Tipi</label>
          <nz-segmented
            [nzOptions]="tipSecenekler"
            [ngModel]="tipIndex()"
            (ngModelChange)="tipDegisti($event)"
            nzBlock>
          </nz-segmented>
          <div class="pde-ipucu">
            @if (tipi() === 'kesin') {
              🎯 <b>Kesin:</b> Projenin mevcut ilerlemesi <b>bu değere</b> ayarlanır
            } @else {
              ➕ <b>Eklemeli:</b> Mevcut ilerlemenin <b>üzerine eklenir</b>
            }
          </div>
        </div>

        <div class="pde-alan">
          <label class="pde-etiket">İlerleme Değeri — <b>{{ tipi() === 'eklemeli' ? '+' : '' }}%{{ deger() }}</b></label>
          <nz-slider
            [ngModel]="deger()"
            (ngModelChange)="guncelle('ilerlemeDegeri', $event)"
            [nzMin]="0"
            [nzMax]="100"
            [nzStep]="5"
            [nzMarks]="marks">
          </nz-slider>
        </div>

        <div class="pde-alan">
          <label class="pde-etiket">Notlar</label>
          <textarea nz-input [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)" placeholder="İlerleme notu..." rows="2"></textarea>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .pde { display:flex; flex-direction:column; gap:10px; padding:4px 0; }
    .pde-baslik { display:flex; align-items:center; gap:8px; padding:8px 12px; background:linear-gradient(135deg, rgba(59,130,246,.08), transparent); border-radius:8px; font-weight:600; font-size:14px; color:var(--py-metin,#333); }
    .pde-ikon { font-size:20px; }
    .pde-form { display:flex; flex-direction:column; gap:10px; }
    .pde-alan { display:flex; flex-direction:column; gap:4px; }
    .pde-etiket { font-size:11px; font-weight:600; color:var(--py-metin-ucuncul,#999); text-transform:uppercase; letter-spacing:.4px; }
    .pde-ipucu { font-size:11px; color:var(--py-metin-ikincil,#666); padding:4px 8px; background:rgba(59,130,246,.06); border-left:2px solid #3b82f6; border-radius:0 4px 4px 0; margin-top:2px; }
    .zorunlu { color:#ef4444; }
  `],
})
export class ProjeTanimiDurumEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  durumlar = DURUMLAR;
  tipSecenekler = [
    { label: '🎯 Kesin', value: 'kesin' },
    { label: '➕ Eklemeli', value: 'eklemeli' },
  ];
  marks = { 0: '0', 25: '25', 50: '50', 75: '75', 100: '100' };

  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});
  tipi = computed(() => this.p()?.ilerlemeTipi || 'kesin');
  tipIndex = computed(() => this.tipi() === 'eklemeli' ? 1 : 0);
  deger = computed(() => +(this.p()?.ilerlemeDegeri ?? 0));
  secilenIkon = computed(() => DURUM_IKON[this.p()?.durum] || '🔄');

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }

  /** Durum seçilince varsayılan değeri öner (boşsa) */
  durumDegisti(yeniDurum: string) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek.durum = yeniDurum;
    const mevcut = params.ek.ilerlemeDegeri;
    if (mevcut == null || mevcut === '' || mevcut === 0) {
      params.ek.ilerlemeDegeri = DURUM_VARSAYILAN_DEGER[yeniDurum] ?? 0;
    }
    if (!params.ek.ilerlemeTipi) params.ek.ilerlemeTipi = 'kesin';
    this.parametreler.set({ ...params });
  }

  tipDegisti(index: number) {
    this.guncelle('ilerlemeTipi', index === 1 ? 'eklemeli' : 'kesin');
  }
}

// ════════════════════════════════════════════════════
// 3b. DURUM ALT KART SADE (sade kart görünümü)
// ════════════════════════════════════════════════════
@Component({
  selector: 'proje-tanimi-durum-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pdk" [style.--dr]="renk()">
      <span class="pdk-ikon">{{ ikon() }}</span>
      <span class="pdk-durum">{{ durum() }}</span>
      @if (ilerlemeVar()) {
        <span class="pdk-chip" [class.pdk-chip--add]="tipi() === 'eklemeli'">
          {{ tipi() === 'eklemeli' ? '+' : '' }}%{{ deger() }}
        </span>
      }
      @if (d('notlar')) { <span class="pdk-not">{{ d('notlar') }}</span> }
    </div>
  `,
  styles: [`
    .pdk { display:flex; align-items:center; gap:8px; padding:6px 10px; border-left:3px solid var(--dr,#94a3b8); border-radius:0 8px 8px 0; background:color-mix(in srgb, var(--dr) 6%, transparent); }
    .pdk-ikon { font-size:16px; }
    .pdk-durum { font-size:13px; font-weight:700; color:var(--dr,#333); text-transform:uppercase; letter-spacing:.5px; }
    .pdk-chip { font-size:11px; font-weight:700; padding:2px 8px; border-radius:10px; background:var(--dr,#94a3b8); color:#fff; font-family:'Consolas',monospace; }
    .pdk-chip--add { background:linear-gradient(135deg, #22c55e, #16a34a); }
    .pdk-not { font-size:12px; color:var(--py-metin-ikincil,#666); margin-left:auto; }
  `],
})
export class ProjeTanimiDurumKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  durum = computed(() => this.d('durum') || 'Planlandı');
  renk = computed(() => DURUM_RENK[this.durum()] || '#94a3b8');
  ikon = computed(() => DURUM_IKON[this.durum()] || '🔄');
  tipi = computed(() => this.d('ilerlemeTipi') || 'kesin');
  deger = computed(() => {
    const v = this.d('ilerlemeDegeri');
    if (v != null && v !== '') return +v;
    // fallback: duruma göre varsayılan
    return DURUM_VARSAYILAN_DEGER[this.durum()] ?? 0;
  });
  ilerlemeVar = computed(() => {
    if (this.durum() === 'İptal') return false;
    return true;
  });
}

// ════════════════════════════════════════════════════
// DECORATORS
// ════════════════════════════════════════════════════
@DinamikBilesen({
  id: 'proje-tanimi',
  baslik: 'Proje Tanımı',
  aciklama: 'Proje takibi ve yönetimi',
  ikon: 'project',
  kategori: 'proje-yonetimi',
})
class ProjeTanimi {
  paylas_kutusu = ProjeTanimiEditComponent;
  paylasilmis_kart_sade = ProjeTanimiKartSadeComponent;
}

@DinamikBilesen({
  id: 'proje-tanimi-durum',
  baslik: 'Proje Durum',
  aciklama: 'Proje durum güncelleme (kesin/eklemeli ilerleme)',
  ikon: 'sync',
  kategori: 'proje-yonetimi',
})
class ProjeTanimiDurum {
  paylas_kutusu = ProjeTanimiDurumEditComponent;
  paylasilmis_kart_sade = ProjeTanimiDurumKartSadeComponent;
}
